import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import CampaignListSearchForm from "./campaign-list-search-form";
import CampaignListTable from "./campaign-list-table";
import Pagination from "../pagination/pagination";

export default function CampaignList(props) {
  const [campaigns, setCampaigns] = useState([]); // campaigns to display (will be populated by an Ajax call);
  const [page, setPage] = useState(1); // page number of the campaign results;
  const [pageCount, setPageCount] = useState(0); // number of pages
  const [search, setSearch] = useState(``); // search string;
  const [sort, setSort] = useState(`-created`); // list sort value;
  const [queryString, setQueryString] = useState(``); // pass to sort and pagination links to maintain search state;

  useEffect(() => {
    // on 'props' change, updating the data used for the query and for the state updates
    const page = Number(_.get(props, `params.page`, 1));
    const search = _.get(props, `location.query.search`, ``);
    const sort = _.get(props, `location.query.sort`, `-created`);

    // also updating the query string, used for pagination
    setQueryString(_.get(props, `location.search`, ``));

    // setting Campaigns to empty so that when going to a different page (1, 2, 3,...)
    // or filtering (by name or date created), to display the loading indicator first
    // otherwise, it would display it only on the initial load of the page
    setCampaigns([]);

    // get the campaign data to display (one page at a time);
    const getCampaigns = () => {
      util
        .getCampaigns({
          page: page,
          search: search,
          sort: sort
        })
        .then(data => {
          setTimeout(() => {
            // setting the data returned from the backend
            setPageCount(Math.ceil(data.count / util.campaignResultsPerPage));
            setCampaigns(data.results.length ? data.results : false);

            // setting the state of the new data, for the UI
            setPage(page);
            setSearch(search);
            setSort(sort);
          }, util.delayList);
        });
    };

    getCampaigns();
  }, [props]);

  const searchSubmit = params => {
    setSearch(params.search);

    browserHistory.push(params.url);
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-5">
          <h4 className="page__title">Campaigns</h4>
        </div>
        <div className="col-xs-7">
          <p className="page__actions">
            <Link to={util.returnCampaignFormUrl()} className="btn btn-primary">
              <i className="fa fa-plus" aria-hidden="true"></i>
              Create New Campaign
            </Link>
          </p>
        </div>
      </div>

      <CampaignListSearchForm
        search={search}
        sort={sort}
        searchSubmit={params => searchSubmit(params)}
      />

      <CampaignListTable
        campaigns={campaigns}
        currentPage={page}
        queryString={queryString}
        sort={sort}
      />

      <Pagination
        currentPage={Number(page)}
        pageCount={Number(pageCount)}
        path="campaigns"
        queryString={queryString}
      />
    </div>
  );
}

CampaignList.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object
};
